export default __webpack_public_path__ + "static/media/design.b0dea6a3.svg";